import { styled } from '@mui/material';

export interface StyledImageContainerProps {
  $top?: string | number;
  $bottom?: string | number;
  $left?: string | number;
  $right?: string | number;
  $rotate?: number;
  $zIndex?: number;
  $size?: number;
}

export const StyledImageContainer = styled('div')<StyledImageContainerProps>(
  ({ $top, $bottom, $left, $right, $rotate, $zIndex = -10, $size }) => ({
    position: 'absolute',
    top: $top,
    bottom: $bottom,
    left: $left,
    right: $right,
    zIndex: $zIndex,
    rotate: $rotate !== undefined ? `${$rotate}deg` : undefined,
    img: $size
      ? {
          height: 'auto',
          width: `${$size}px`,
        }
      : undefined,
  }),
);
